export default __webpack_public_path__ + "static/media/regreen_visual_03.1a3a67ae.jpg";